import { Box } from '@factorialco/deprecated-design-system'
import { BarChart } from '@factorialco/f0-react'

import { SupportedColors } from './types'

type ChartData = {
  status?: string
  color?: SupportedColors
  label: string
  value: { [key: string]: number }
  formattedValue?: string
}

interface BarChartWrapperProps {
  groupedChartData: ChartData[]
  barLabels: { [key: string]: { label: string; color?: SupportedColors } }
  tickFormatter: (value: string) => string
  type: 'stacked' | 'stacked-by-sign' | 'simple'
  aspect: 'small' | 'wide'
  displayAxis?: boolean
}

export const BarChartWrapper = ({
  groupedChartData,
  barLabels,
  tickFormatter,
  type,
  aspect,
  displayAxis = true,
}: BarChartWrapperProps) => {
  const barChartData = groupedChartData.map((x) => ({
    label: x.label,
    values: x.value,
  }))

  return (
    <Box width="full" height="full">
      <BarChart
        data={barChartData}
        dataConfig={barLabels}
        type={type}
        xAxis={{
          hide: !displayAxis,
        }}
        yAxis={{
          hide: !displayAxis,
          tickFormatter,
        }}
        aspect={aspect}
      />
    </Box>
  )
}
